import React from 'react';
import styles from './CheckEmail.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { MdOutlineEmail } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { appRoutes } from '@/routes';

export const CheckEmailComponent = () => {
  return (
    <div className={styles.checkEmailPage}>
      <div className={styles.checkEmailPageHeader}>
        <img src={'/svg/logo.svg'} alt="Prodaff" style={{ width: 75 }} />
        <Text
          variant={textVariantsEnum.Text_25}
          fontWeight={fontWeightEnum.Semibold}
        >
          Prodaff
        </Text>
      </div>
      <div className={styles.checkEmailPageContent}>
        <div className={styles.checkEmailBox}>
          <MdOutlineEmail size={55} color="#667085" />
          <Text
            variant={textVariantsEnum.Text_25}
            fontWeight={fontWeightEnum.Semibold}
            style={{ marginTop: 24 }}
          >
            Check your email
          </Text>
          <Text
            variant={textVariantsEnum.Text_15}
            fontWeight={fontWeightEnum.Medium}
            color={'gray-400'}
            style={{ marginTop: 12, marginBottom: 24 }}
          >
            We've sent a verification link to your email.
          </Text>
          <Link to={appRoutes().login}>
            <Text
              variant={textVariantsEnum.Text_lg}
              fontWeight={fontWeightEnum.Medium}
              style={{ color: '#3363f5' }}
            >
              Go back to sign in
            </Text>
          </Link>
        </div>
      </div>
    </div>
  );
};
